<template>
  <el-dialog
    :title="this.projectGroupID === null ? '新增项目组' : '编辑项目组'"
    :visible.sync="dialogFormVisible"
    :close-on-click-modal="false"
    custom-class="custom_dialog"
  >
    <el-row>
      <el-col :span="22" :offset="1">
        <el-form
          :model="projectGroupForm"
          :rules="projectGroupFormRules"
          ref="projectGroupForm"
          label-width="170px"
          class="demo-ruleForm"
          size="mini"
          :label-position="is_xs ? 'top' : 'right'"
        >
          <el-form-item label="项目组名称：" prop="Name">
            <el-input
              v-model="projectGroupForm.Name"
              autocomplete="off"
              placeholder="请输入项目组名称"
            ></el-input>
          </el-form-item>
          <el-form-item label="显示顺序：">
            <el-col :span="16">
              <el-form-item class="el-form-item-internal" prop="Sort">
                <el-input
                  v-model="projectGroupForm.Sort"
                  oninput="value=value.replace(/[^\d]/g,'')"
                  :max="1000000"
                  autocomplete="off"
                  placeholder="请输入排序序号"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-form-item>
          <el-form-item label="排序（投屏分组排序）：">
            <el-col :span="16">
              <el-form-item class="el-form-item-internal" prop="Sort">
                <el-input
                  v-model="projectGroupForm.SupplementSort"
                  oninput="value=value.replace(/[^\d]/g,'')"
                  :max="1000000"
                  autocomplete="off"
                  placeholder="请输入排序序号"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible = false">取 消</el-button>
      <el-button type="primary" @click="saveProjectGroup('projectGroupForm')"
        >确 定</el-button
      >
    </div>
  </el-dialog>
</template>

<script>
import voteProjectApi from '../../api/vote/voteProject'
export default {
  name: 'EditRule',
  data () {
    const validateSort = (rule, value, callback) => {
      if (value >= 1000000) {
        callback(new Error('排序值必须小于7位数！'))
      } else {
        callback()
      }
    }
    return {
      projectGroupForm: {
        Id: null,
        MeetId: null,
        Name: null,
        Sort: null,
        SupplementSort: null
      },
      projectGroupFormRules: {
        Name: [
          { required: true, message: '请输入项目组名称', trigger: 'blur' },
          { min: 1, max: 50, message: '名称长度最多50个字符。', trigger: 'blur' }],
        Sort: [
          { validator: validateSort, trigger: 'blur' }],
        SupplementSort: [
          { validator: validateSort, trigger: 'blur' }]
      },
      dialogFormVisible: false,
      projectGroupID: null
    }
  },
  props: {
    meetId: { type: String },
    fatherSubmitDialog: {
      type: Function,
      default: null
    }
  },
  methods: {
    getProjectGroup: function () {
      voteProjectApi.getProjectGroup({
        projectGroupId: this.projectGroupID
      }).then(data => {
        this.projectGroupForm = data
        this.openLoading().close()
      }).catch(err => {
        this.openLoading().close()
        return err
      })
    },
    saveProjectGroup: function (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.openLoading('保存中…')
          voteProjectApi.editProjectGroup(this.projectGroupForm).then(data => {
            this.openLoading().close()
            this.$message({
              showClose: true,
              type: 'success',
              message: '保存成功!',
              customClass: 'custom_message'
            })
            this.dialogFormVisible = false
            this.fatherSubmitDialog()
          }).catch(err => {
            this.openLoading().close()
            this.dialogFormVisible = false
            this.fatherSubmitDialog()
            return err
          })
        } else {
          return false
        }
      })
    },
    openEditProjectGroup: function (projectGroupID) {
      this.openLoading()
      this.dialogFormVisible = true
      this.projectGroupID = projectGroupID
      if (!projectGroupID) {
        this.projectGroupForm = {}
        this.projectGroupForm.MeetId = this.meetId
        this.openLoading().close()
      } else {
        this.getProjectGroup()
      }
    }
  },
  created () {

  }
}
</script>
<style lang="less">
</style>
